// extracted by mini-css-extract-plugin
export default {"descriptionTerms":"termsUse_descriptionTerms__qE0Pv","button":"termsUse_button__3o900"};